import React from 'react';

import { Header } from 'formlabs-web-components/Type';

import './TabbedSection.module.css';

const TabbedSectionItem = ({ children, name, shortDescription }) => {
  return (
    <section styleName="tab-content">
      <Header level={1} displayAs={2}>
        {name}
      </Header>
      <p styleName="subtitle">{shortDescription}</p>
      <div styleName="body">{children}</div>
    </section>
  );
};

export default TabbedSectionItem;
